exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-aktualijos-wp-post-slug-js": () => import("./../../../src/pages/aktualijos/{wpPost.slug}.js" /* webpackChunkName: "component---src-pages-aktualijos-wp-post-slug-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

